import { styled } from "@mui/material";

interface ComponentProps {
    handleEdit: () => void;
    handleDelete: () => void;
}

const ViewContent: React.FC<ComponentProps> = ({ handleDelete, handleEdit}) => {
    return (
        <>
            <StyledCardText onClick={handleEdit}>Edit Details</StyledCardText>
            {/* <StyledCardText onClick={handleDelete}>Delete Route</StyledCardText> */}
        </>
    )
}

export default ViewContent;

const StyledCardText = styled('button')`
    cursor: pointer;
    padding-inline-start: 1.2rem;
    padding-block: 0.4rem;
    font-size: 1rem;
    color: #232323;
    border: none;
    background-color: transparent;
    text-align: left;
    &:hover {
        background-color: #f1f1f1;
    }
    
`